import { createReducer, on } from '@ngrx/store';

import * as FilterActions from './filter.actions';
import { initialFilterState } from './filter.state';

export const APP_FILTERS_FEATURE_KEY = 'appFilters';

export const filterReducer = createReducer(
  initialFilterState,

  on(FilterActions.setRouteConfig, (state, config) => ({
    ...state,
    routeConfig: {
      filterBarSettings:
        config.filterBarSettings || state.routeConfig.filterBarSettings,
      urlParamConfig: config.urlParamConfig || state.routeConfig.urlParamConfig,
      navigationConfig:
        config.navigationConfig || state.routeConfig.navigationConfig,
    },
  })),

  // URL loading actions
  on(FilterActions.loadFiltersFromUrl, (state) => ({
    ...state,
    isLoading: true,
  })),

  on(
    FilterActions.loadFiltersFromUrlSuccess,
    (state, { filterBars, filterSnapshotRefs }) => ({
      ...state,
      filterBars: {
        ...state.filterBars,
        ...filterBars,
      },
      filterSnapshotRefs: {
        ...state.filterSnapshotRefs,
        ...(filterSnapshotRefs ?? {}),
      },
      isLoading: false,
    })
  ),

  // Filter update actions
  on(FilterActions.updateFilters, (state, { filterBarId }) => ({
    ...state,
    // Filters changed → the snapshot ref is derived state and must not linger
    // (it referenced the OLD set). Cleared HERE (synchronous, on the user's
    // filter change) rather than in the async `updateFiltersSuccess` effect:
    // the grid's purge-refresh defers `getRows`, and `getDevices` reads this
    // ref synchronously, so clearing on `updateFiltersSuccess` left a window
    // where the grid queried the OLD snapshot with the NEW args (EDUS-2575).
    // A null ref is the "recompute from scratch" signal — the next query
    // re-measures the new filters (inlines them, or mints a fresh snapshot).
    filterSnapshotRefs: {
      ...state.filterSnapshotRefs,
      [filterBarId || 'default']: null,
    },
    isLoading: true,
  })),

  on(FilterActions.updateFiltersSuccess, (state, { filters, filterBarId }) => ({
    ...state,
    filterBars: {
      ...state.filterBars,
      [filterBarId || 'default']: filters || [],
    },
    isLoading: false,
  })),

  on(
    FilterActions.setFilterSnapshotRef,
    (state, { filterBarId, snapshotRef }) => ({
      ...state,
      filterSnapshotRefs: {
        ...state.filterSnapshotRefs,
        [filterBarId || 'default']: snapshotRef,
      },
    })
  ),

  on(FilterActions.setFilterBarSettings, (state, { settings }) => ({
    ...state,
    routeConfig: {
      ...state.routeConfig,
      filterBarSettings: settings,
    },
  })),

  on(FilterActions.setCurrentUrlParamConfig, (state, { config }) => ({
    ...state,
    currentConfig: config,
  })),

  on(FilterActions.setNavigationConfig, (state, { navigationConfig }) => ({
    ...state,
    currentNavigationConfig: navigationConfig,
  })),

  // Clear filters
  on(FilterActions.clearFilters, (state, { filterBarId }) => ({
    ...state,
    filterBars: filterBarId ? { ...state.filterBars, [filterBarId]: [] } : {},
    filterSnapshotRefs: filterBarId
      ? { ...state.filterSnapshotRefs, [filterBarId]: null }
      : {},
  }))
);
